import React, { useEffect, useRef, useState } from "react";
import "./CreateSitesGlobal.scss";

import { Button, Form, Modal } from "react-bootstrap";

import { DomainAdd } from "@mui/icons-material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BASE_URL,
  PPE_getApiSync,
  getValueFromLocalStorageFunc,
  notify,
} from "../../../services/functions";

import { ToastContainer } from "react-toastify";

import { faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Users } from "../../list/Users/oldindex";

const ModalCreateMembers = (props) => {
  const { par_show, status, row, outChange } = props;

  const [show, setShow] = useState(false);

  const [userList, setUserList] = useState<Users[]>([]);
  const [roleList, setRoleList] = useState<
    { id: number; name: string; description: string }[]
  >([]);

  // const reverseRoleMap = {
  //   superadmin: 1,
  //   user: 2,
  //   admin: 3,
  // };

  const [objValueInput, setObjValueInput] = useState({
    name: "",
    description: "",
    id_head: "",
    role: 2,
  });

  const refEmailInput = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setShow(par_show ?? false);

    if (par_show) {
      fetchUserList();
      fetchRoleList();
    }

    if (status === "Edit") {
      const roleFromRow =
        typeof row.role === "string"
          ? (roleList.find(
              (r) => r.name.toLowerCase() === row.role.toLowerCase(),
            )?.id ?? 2)
          : (row.role ?? 2);

      setObjValueInput({
        name: row?.name ?? "",
        description: row?.description ?? "",
        id_head: row?.id_head ?? "",
        // role:
        //   typeof row.role === "string" && reverseRoleMap[row.role.toLowerCase()]
        //     ? reverseRoleMap[row.role.toLowerCase()]
        //     : 2,
        role: roleFromRow,
      });
    } else {
      setObjValueInput({ name: "", description: "", id_head: "", role: 2 });
    }

    setTimeout(() => {
      if (refEmailInput.current) {
        refEmailInput.current.focus();
        refEmailInput.current.select();
      }
    }, 100);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [par_show, status, row]);

  const fetchUserList = () => {
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const apiUrl = `${BASE_URL}/v1/users/list?limit=1000&offset=0`;

    PPE_getApiSync(apiUrl, null, "application/json", "GET", token)
      .then((response) => {
        if (Array.isArray(response)) {
          setUserList(response);
        } else {
          notify("error", "Unexpected user data format", "TOP_CENTER");
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching user list:", err);
        notify("error", "Failed to fetch user list", "TOP_CENTER");
      });
  };

  const fetchRoleList = () => {
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const apiUrl = `${BASE_URL}/v1/roles/list`;

    PPE_getApiSync(apiUrl, null, "application/json", "GET", token)
      .then((response) => {
        if (Array.isArray(response)) {
          setRoleList(response);
        } else {
          notify("error", "Unexpected role data format", "TOP_CENTER");
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching role list:", err);
        notify("error", "Failed to fetch role list", "TOP_CENTER");
      });
  };

  const handleHide = () => {
    setShow(false);
    outChange(false);
  };

  const handleChangeInput = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    tipeInput: string,
  ) => {
    let value: any = event.target.value;

    if (tipeInput === "role") {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      value = Number(value);
    }

    setObjValueInput((obj) => ({
      ...obj,
      [tipeInput]: event.target.value,
    }));
  };

  const handleSubmit = () => {
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    console.log("🔐 Token used for API request Create Members:", token);
    const methodhit = status === "Create" ? "POST" : "PUT";
    const endpoint =
      status === "Create"
        ? `${BASE_URL}/v1/members/create`
        : `${BASE_URL}/v1/members/${row?.id}`;

    const objSubmitToAPI = {
      name: objValueInput.name,
      description: objValueInput.description,
      id_head: objValueInput.id_head,
      role: objValueInput.role,
    };

    console.log("Role type:", typeof objSubmitToAPI.role);
    console.log("[CreateMembers] objValueInput", objValueInput);
    console.log("Submit Data Member:", objSubmitToAPI);

    PPE_getApiSync(
      endpoint,
      objSubmitToAPI,
      "application/json",
      methodhit,
      token,
    )
      .then((response) => {
        const statusCodeError = response?.statusCode;
        if (statusCodeError) {
          notify("error", response?.msg, "TOP_CENTER");
          return;
        }

        notify("success", "Your data was saved!", "TOP_CENTER");

        setShow(false);
        outChange({
          tipe: "close_after_success_save",
          value: false,
          form: "create",
        });
      })
      .catch((error) => {
        notify(
          "error",
          "An error occurred. Please try again later.",
          "TOP_CENTER",
        );
      });
  };

  return (
    <>
      <Modal show={show} centered size="sm" backdrop={true} onHide={handleHide}>
        <Modal.Header
          className={`modalheader modal-header-global ${
            status === "Edit" ? "edit" : "create"
          }`}
        >
          <Modal.Title className={`dashboard-modal-title`}>
            {status === "Create" && (
              <>
                <DomainAdd
                  style={{
                    position: "absolute",
                    right: 15,
                    top: 25,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                  className={`login-dropdown-icon`}
                />
                <FontAwesomeIcon
                  icon={faPlus}
                  className={`login-dropdown-icon`}
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 10,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                />
              </>
            )}

            {status === "Edit" && (
              <>
                <DomainAdd
                  style={{
                    position: "absolute",
                    right: 20,
                    top: 25,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                  className={`login-dropdown-icon`}
                />
                <FontAwesomeIcon
                  icon={faPencil}
                  className={`login-dropdown-icon`}
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: -2,
                    top: 15,
                    zIndex: 0,
                    transform: "scale(1.5)",
                  }}
                />
              </>
            )}
            <span className="login-icon-modal-title">Create Member</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex" }} className="row">
            <Form.Group className="mb-1 col-12" controlId="id-name">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Member Name
              </Form.Label>
              <Form.Control
                type="text"
                className="modal-input-placeholder"
                placeholder="Enter Member Name"
                maxLength={100}
                ref={refEmailInput}
                value={objValueInput.name}
                onChange={(event) =>
                  handleChangeInput(
                    event as React.ChangeEvent<HTMLInputElement>,
                    "name",
                  )
                }
              />
            </Form.Group>

            <Form.Group className="mb-1 col-12" controlId="id-description">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Description
              </Form.Label>
              <Form.Control
                type="text"
                className="modal-input-placeholder"
                placeholder="Enter Description"
                maxLength={250}
                value={objValueInput.description}
                onChange={(event) =>
                  handleChangeInput(
                    event as React.ChangeEvent<HTMLInputElement>,
                    "description",
                  )
                }
              />
            </Form.Group>

            {/* <Form.Group className="mb-1 col-12" controlId="id-head">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Head ID
              </Form.Label>
              <Form.Control
                type="number"
                className="modal-input-placeholder"
                value={objValueInput.id_head}
                onChange={(event) =>
                  handleChangeInput(
                    event as React.ChangeEvent<HTMLInputElement>,
                    "id_head"
                  )
                }
              />
            </Form.Group> */}

            <Form.Group className="mb-1 col-12" controlId="id-head">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Head ID
              </Form.Label>
              <Form.Select
                className="modal-input-placeholder"
                value={objValueInput.id_head}
                onChange={(event) =>
                  handleChangeInput(
                    event as React.ChangeEvent<HTMLSelectElement>,
                    "id_head",
                  )
                }
              >
                <option value="">-- Select Head --</option>
                {userList.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name} ({user.email})
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* <Form.Group className="mb-1 col-12" controlId="id-role">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Role
              </Form.Label>
              <Form.Control
                type="number"
                className="modal-input-placeholder"
                value={objValueInput.role}
                onChange={(event) =>
                  handleChangeInput(
                    event as React.ChangeEvent<HTMLInputElement>,
                    "role",
                  )
                }
              />
            </Form.Group> */}
            <Form.Group className="mb-1 col-12" controlId="id-role">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Role
              </Form.Label>
              {/* <Form.Select
                value={objValueInput.role}
                onChange={(e) => handleChangeInput(e, "role")}
              >
                <option value={1}>1 - Superadmin</option>
                <option value={2}>2 - User</option>
                <option value={3}>3 - Admin</option>
              </Form.Select> */}
              <Form.Select
                value={objValueInput.role}
                onChange={(e) => handleChangeInput(e, "role")}
              >
                <option value="">Select Role</option>
                {roleList.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.id} - {role.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleSubmit()}>
            Save
          </Button>
          <Button variant="secondary" onClick={() => handleHide()}>
            Close
          </Button>
        </Modal.Footer>

        <ToastContainer draggable pauseOnHover />
      </Modal>
    </>
  );
};

export default ModalCreateMembers;
